// extracted by mini-css-extract-plugin
export var flush = "FVFbMB2iX0QJL_B1uZNj";
export var headerWithIcon = "QqwlV4bnnEnSgcYwf66w";
export var leftBorder = "EJo9XD1z0CLwQ2eu3tvY";
export var leftBorderInfo = "l9EaAWi9nN8LoPpHfGfc";
export var leftBorderNegative = "MyWnIwVHSdOIHr7V4kOW";
export var leftBorderPositive = "u0qsl0AhqXThUVQEeJ9O";
export var leftBorderWarning = "PXhXm6Fl1EdCUBB9JJtH";
export var message = "Z6g9cwTBzxwHhOwPb7_c";
export var messageHeader = "sxYwfjZ4_W0KPHQviV5E";
export var trailingItem = "dExDRbJdZv2OPLaZUvHH";
export var vertical = "wOoxdpo9T023ok_rRz_F";